import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./bulk-update-team.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./bulk-update-team.component.scss?ngResource";
import { ChangeDetectionStrategy, Component, Inject, Input } from "@angular/core";
import { APP_BASE_HREF } from "@angular/common";
import { BulkUpdateTeamConstants } from "./bulk-update-team.constants";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { SharedConstants } from "src/app/shared/constants/shared.constants";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { AlertType } from "src/app/shared/models/alert";
import { AppConfig } from "src/app/app.config";
import { AppControllerService } from "src/app/app-controller.service";
import { Subject, take, takeUntil } from "rxjs";
import { BulkUpdateTeamService } from "./service/bulk-update-team.service";
import { CRUDOperation } from "src/app/shared/models/crud-operation-enum.model";
let BulkUpdateTeamComponent = class BulkUpdateTeamComponent {
    baseHref;
    modalService;
    appController;
    bulkUpdateTeamService;
    _destroy$ = new Subject();
    title;
    jobId;
    moduleId;
    description;
    teamRoles;
    bulkUpdateTeamForm;
    branding = {
        themeMainColor: SharedConstants.DEFAULT_COLOR,
        themeMainDarkerColor: SharedConstants.DEFAULT_DARKER_COLOR,
        themeMainBackgroundColor: SharedConstants.DEFAULT_COLOR,
        themeMainBorderColor: SharedConstants.DEFAULT_COLOR,
        themeHeaderBorderColor: SharedConstants.DEFAULT_HEADER_BORDER_COLOR,
        themeActiveColor: SharedConstants.DEFAULT_ACTIVE_COLOR,
        themeActiveAlternateColor: SharedConstants.DEFAULT_ACTIVE_ALTERNATE_COLOR,
        themePrimaryButtonColor: SharedConstants.DEFAULT_PRIMARY_BUTTON_COLOR
    };
    titleLabel = BulkUpdateTeamConstants.TITLE_LABEL;
    cancelBtnLabel = BulkUpdateTeamConstants.CANCEL_BTN_LABEL;
    continueBtnLabel = BulkUpdateTeamConstants.CONTINUE_BTN_LABEL;
    noRoleSelected = BulkUpdateTeamConstants.NO_ROLE_SELECTED;
    teamRoleformControlName = BulkUpdateTeamConstants.TEAM_ROLE_FORM_CONTROL_NAME;
    currentAssignedUserformControlName = BulkUpdateTeamConstants.CURRENT_ASSIGNED_USER_FORM_CONTROL_NAME;
    newAssignedUserformControlName = BulkUpdateTeamConstants.NEW_ASSIGNED_USER_CONTROL_NAME;
    formValidationMessage = BulkUpdateTeamConstants.FORM_VALIDATION_MESSAGE;
    selectedTeamRole;
    selectedTeamRoleUsers;
    constructor(baseHref, modalService, appController, bulkUpdateTeamService) {
        this.baseHref = baseHref;
        this.modalService = modalService;
        this.appController = appController;
        this.bulkUpdateTeamService = bulkUpdateTeamService;
        if (AppConfig.settings.projectSettings && AppConfig.settings.projectSettings.styling) {
            this.branding = AppConfig.settings.projectSettings.styling;
        }
    }
    ngOnInit() {
        this.initForm();
    }
    initForm() {
        this.bulkUpdateTeamForm = new FormGroup({
            "teamRole": new FormControl(null, Validators.required),
            "currentAssignedUserformControlName": new FormControl(null, Validators.required),
            "newAssignedUserformControlName": new FormControl(null, Validators.required),
        });
    }
    onSelectTeamRoleChanged() {
        const role = this.bulkUpdateTeamForm.get(this.teamRoleformControlName).value;
        if (role == undefined) {
            this.appController.showMessage(this.noRoleSelected, AlertType.Warning);
        }
        else {
            this.selectedTeamRoleUsers = this.teamRoles.find(x => x.role == role).users;
        }
    }
    onBtnCancelClicked() {
        this.modalService.close();
    }
    getRoleName() {
        const role = this.bulkUpdateTeamForm.get(this.teamRoleformControlName).value;
        return role;
    }
    getAssignedUserId() {
        const role = this.bulkUpdateTeamForm.get(this.currentAssignedUserformControlName).value;
        return role;
    }
    getNewAssignedUserId() {
        const role = this.bulkUpdateTeamForm.get(this.newAssignedUserformControlName).value;
        return role;
    }
    onBtnContinueClicked() {
        if (this.bulkUpdateTeamForm.invalid) {
            this.appController.showMessage(this.formValidationMessage, AlertType.Warning);
            return;
        }
        const role = this.getRoleName();
        const oldUserId = this.getAssignedUserId();
        const newUserId = this.getNewAssignedUserId();
        const params = {
            moduleId: this.moduleId,
            jobId: this.jobId,
            roleName: role,
            assignedUserId: oldUserId,
            newAssignedUserId: newUserId
        };
        this.bulkUpdateTeamService.postBulkUpdateTeam(params).pipe(takeUntil(this._destroy$), take(1)).subscribe({
            next: (appSaveresponse) => {
                this.appController.showMessage(SharedConstants.ADD_SUCCESS, AlertType.Success);
                this.modalService.close(appSaveresponse);
            }, error: (error => {
                this.appController.handleServerErrorMessage("Error Updating team", error, CRUDOperation.Saving);
            })
        });
    }
    static ctorParameters = () => [
        { type: String, decorators: [{ type: Inject, args: [APP_BASE_HREF,] }] },
        { type: NgbActiveModal },
        { type: AppControllerService },
        { type: BulkUpdateTeamService }
    ];
    static propDecorators = {
        title: [{ type: Input }],
        jobId: [{ type: Input }],
        moduleId: [{ type: Input }],
        description: [{ type: Input }],
        teamRoles: [{ type: Input }]
    };
};
BulkUpdateTeamComponent = __decorate([
    Component({
        selector: "app-bulk-update-team",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], BulkUpdateTeamComponent);
export { BulkUpdateTeamComponent };
